// extracted by mini-css-extract-plugin
export default {"select_wrapper":"LanguageSelector_select_wrapper__4Wjy9","select":"LanguageSelector_select__UUv0r"};